import { buttonClasses, SxProps } from '@mui/material'
import { calendarDimensions } from '../DateRangePicker.data'
import { dateRangePickerMonthsClasses as classes } from './DateRangePickerMonths.data'

interface DateRangePickerMonthsStyles {
  wrapper: SxProps
  monthsWrapper: SxProps
  button: SxProps
  text: SxProps
}

export const dateRangePickerMonthsStyles: DateRangePickerMonthsStyles = {
  wrapper: {
    height: calendarDimensions.height,
  },
  monthsWrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px 20px',
  },
  button: {
    height: 35,
    width: '100%',
    maxWidth: 125,
    borderRadius: 5,
    mx: 'auto',

    [`&:hover:not(.${buttonClasses.disabled}), &.${classes.selected}`]: {
      color: 'text.primaryContrast',
      backgroundColor: 'brand.primary600',
    },
    [`&.${buttonClasses.disabled}`]: {
      color: 'text.disabled',
    },
  },
  text: {
    typography: 'textSm',
  },
}
